import 'reflect-metadata';
import {Expose} from 'class-transformer';

import {Enum} from '@/app/shared/enum/enum';

export namespace Shared {
  export namespace Response {
    export class Result {
      @Expose()
      action!: Enum.CORE.RESULT;

      @Expose()
      data!: any;
    }
  }

  export class Options {
    @Expose()
    value!: string | number | boolean | null;

    @Expose()
    text!: string;

    @Expose()
    disabled?: boolean = false;

    constructor(text?: string, value?: string | number | boolean | null, disabled?: boolean) {
      if (!!text) {
        this.text = text;
      }

      if (value !== null && value !== undefined) {
        this.value = value;
      }

      if (disabled !== null && disabled !== undefined) {
        this.disabled = disabled;
      }
    }
  }
}
